// Session timing constants in minutes

// How many minutes before a session starts that users can join
export const EARLY_JOIN_MINUTES = 5;

// How many minutes after a session ends that users can still join
export const LATE_JOIN_MINUTES = 15;

// How many minutes after a session ends to consider it "recently ended"
export const RECENTLY_ENDED_MINUTES = 60;